import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import React from "react";
import TransmissionReportLogUserForm from "../TransmissionReportLogUserForm";
import useTransmissionReportLog from "../useTransmissionReportLog";

const TransmissionReportLogUserModal = ({ onClose }) => {
  const {
    selectedUser,
    isDownloading,
    isFetchingProgressReport,
    getTransmissionReportLogs,
    getUserProgressReport,
  } = useTransmissionReportLog();

  return (
    <ModalWrapper
      show={true}
      showTitle={true}
      maxWidth="sm"
      maxHeight="sm"
      showCloseIcon={true}
      headerStyle={{ padding: "4px 24px" }}
      onClose={onClose}
      title="Select a user"
      children={<TransmissionReportLogUserForm />}
      actionButtons={[
        {
          label: "Cancel",
          variant: "outlined",
          color: "secondary",
          onClick: onClose,
          disabled: isDownloading || isFetchingProgressReport,
        },
        {
          label: "View Progress",
          color: "primary",
          variant: "contained",
          disabled: !selectedUser || isDownloading,
          isLoading: isFetchingProgressReport,
          onClick: getUserProgressReport,
        },
        {
          label: "Download",
          color: "secondary",
          variant: "contained",
          disabled: !selectedUser || isFetchingProgressReport,
          isLoading: isDownloading,
          onClick: getTransmissionReportLogs,
        },
      ]}
    />
  );
};

export default TransmissionReportLogUserModal;
